import React from "react";
import  ReactDOM  from "react-dom";



function Footer(){
   return(<div className="footer container-fluid">

      <a className="footer-icon" href="https://twitter.com/siya_vats"><i class="fa-brands fa-twitter"></i></a>
      <a className="footer-icon"><i class="fa-brands fa-linkedin"></i></a>
      <a className="footer-icon" href="https://www.instagram.com/siya_vats06/"><i class="fa-brands fa-instagram"></i></a>
      <a className="footer-icon" href="https://github.com/SiyaVats06"><i class="fa-brands fa-github"></i></a>
        <h6 className="footer-text">Copyright@ Siya Vats</h6>
       
   </div>

   );



}
export default Footer;